import React, { useEffect, useState } from "react";
import Content from "../../../layout/content/Content";
import { useForm } from "react-hook-form";
import { Block, Button, DocumentScan } from "../../../components/Component";
import { apiRequest } from "../../../utils/Api";
import Head from "../../../layout/head/Head";
import { Document, Page, pdfjs } from "react-pdf";
import { Col, Row } from "reactstrap";
import pdfFile from "./document5.pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
const Pdf = () => {
  const [text, setText] = useState();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [data, setData] = useState();

  const getPdf = async () => {
    console.log("get pdf");
    console.log(getValues())

    await apiRequest(`/customer/a/pdf/${getValues('uuid')}?base64=true`, "get").then(
      async (response) => {
        console.log(response.data);
        setData(response.data);
      },
    );
  };


  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(6);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const prevPage = () => {
    setPageNumber(pageNumber <= 1 ? 1 : pageNumber - 1);
  };

  const nextPage = () => {
    setPageNumber(pageNumber + 1 >= numPages ? pageNumber : pageNumber + 1);
  };
  return (

    <React.Fragment>

      <Head title="Report creator"></Head>

      <form className="is-alter" onSubmit={handleSubmit(getPdf)} autoComplete="off">
        <div className="gy-4 row">
          <div className="entry">
            <Row>
              <Col className="col-12 col-md-12 col-sm-12 col-xl-6 col-lg-6">
                <div className="form-control-wrap">
                  <span className="nk-kycfm-label-text">
                    <b>UUID</b>
                    <span className="text-danger">&nbsp;*</span>
                  </span>
                  <div className="input-group input-group-lg">
                    <input
                      type="text"
                      name="uuid"
                      className="form-control"
                      // value={watch("uuid")}
                      {...register('uuid', { required: true })}
                      placeholder="UUID"
                    />


                  </div>
                </div>
              </Col>
            </Row>

          </div>
        </div>
      </form>

      <Row>
        <Button onClick={getPdf}>get pdf</Button>
      </Row>


      {data && <Row>
        <div className="align-items-center justify-content-center">
          <div>
            <i className="bi bi-arrow-left-square-fill display-5 text-danger pointer" onClick={prevPage} role="button">
              prev
            </i>
            <i className="bi bi-arrow-right-square-fill display-5 text-danger pointer" onClick={nextPage} role="button">
              next
            </i>
          </div>
          {data && (
            <Document file={`data:application/pdf;base64,${data}`} onLoadSuccess={onDocumentLoadSuccess} style={{ width: '100%' }}>
              <Page pageNumber={pageNumber} width={1000} />
            </Document>
          )}
        </div>
      </Row>}

    </React.Fragment>
  );
};

export default Pdf;
